import React, { Component } from 'react';
import { connect } from 'react-redux'
import CustomSelect from '../../components/common/select/Select'
import GeoMiddleware from '../../store/prat_middleware/gt/geoMiddleware'
import TemporaryMiddleware from '../../store/prat_middleware/gt/temporaryMiddleware'
import { openDB } from 'idb';
import IsGeographic from './validation/geographisSection'


let isSaveDraft = false
let isEmpty;
let geoData = []
let productData = []
let geoFlags = []
class GeographicDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedGeoRegions: [],
      selectedGeoAreas: [],
      selectedGeoTerritories: [],
      selectedDirectCustomer: [],
      selectedGeoDistributors: [],
      geoDistributorsOnResgion: [],
      myGeoDistributorsOnResgion: [],
      myAreas: [],
      myTerritories: [],
      myDistributors: [],
      matched: false,
      isExtend:true,
      selectedAllRegionsFlag:null,
      selectedAllAreasFlag:null,
      selectedAllTerritoriesFlag:null,
      selectedAllDistributorsFlag:null
    }
    if (this.props.draftData) {
      // log("draftData=>", this.props.draftData)
      this.getGeoData()
    }
  }

  firstTimeData(geo_areas, geo_territories, geo_distributors, geoDistributorsOnResgion) {
    // console.log(geo_distributors, 'geo_distributors')
    isSaveDraft = true
    const getData = async () => {
      if (!("indexedDB" in window)) {
        console.warn("IndexedDB not supported");
        return;
      }
      const dbName = "gt_form";
      const storeName = "product_store";
      const version = 1; //versions start at 1

      const db = await openDB(dbName, version, {

      });
      let result = await db
        .transaction(storeName)
        .objectStore(storeName)
        .get("geo_detail");

      let product_customer = await db
        .transaction(storeName)
        .objectStore(storeName)
        .get("product_detail");

        let getGeoFlags = await db
        .transaction(storeName)
        .objectStore(storeName)
        .get("selectedAllGeoFlags");

      geoData = result ? result.value : []
      productData = product_customer ? product_customer.value : []
      geoFlags = getGeoFlags ? getGeoFlags.value : []
    
      geoData = geoData[0] ? geoData[0] : geoData
      geoFlags = geoFlags[0] ? geoFlags[0] : geoFlags

      let __customer = this.props.draftData?.ActivityMetadata?.product_detail?.direct_customers
      if (geoData.length !== 0) {
        if (this.props.currentForm === 'gt' || this.props.currentForm === 'ic') {

          this.setState({ matched: true })
          isSaveDraft = true
          if (geoData.regions && geo_areas) {
            let filteredAreas = [];
            for (let i = 0; i < geoData.regions.length; i++) {
              filteredAreas.push(
                ...geo_areas.filter(item => {       // eslint-disable-line
                  return item.Region === geoData.regions[i];
                })
              );
            }
            this.setState({ myAreas: filteredAreas })
          }
          geoData = geoData[0] ? geoData[0] : geoData
          if (geoData.areas && geo_territories) {
            let filteredtowns = []
            for (let i = 0; i < geoData.areas.length; i++) {
              filteredtowns.push(
                ...geo_territories.filter(item => {       // eslint-disable-line
                  return item.Area === geoData.areas[i];
                })
              );
            }
            this.setState({ myTerritories: filteredtowns })
          }

          if (geoData.territories && geo_distributors) {
            let filtereddistributors = []
            for (let i = 0; i < geoData.territories.length; i++) {
              filtereddistributors.push(
                ...geo_distributors.filter(item => {       // eslint-disable-line
                  return item.Territory === geoData.territories[i];
                })
              );
            }
            // log(filtereddistributors, geoData.territories, geo_distributors)
            this.setState({ myDistributors: filtereddistributors })
          }

          if (geoData.regions) {
            this.setState({ selectedGeoRegions: geoData.regions })
          }
          if (geoData.areas) {
            this.setState({ selectedGeoAreas: geoData.areas })
          }
          if (geoData.territories) {
            this.setState({ selectedGeoTerritories: geoData.territories })
          }

          if (geoData.distributors) {
            if (this.props.currentForm === 'gt' || this.props.currentForm === 'ic') {
              this.setState({ selectedGeoDistributors: geoData.distributors })
            }
          }

          if(geoFlags.regions === true || geoFlags.regions === false || geoFlags.regions == null){
            this.setState({selectedAllRegionsFlag:geoFlags.regions})
          }
          if(geoFlags.areas === true || geoFlags.areas === false || geoFlags.areas == null){
            this.setState({selectedAllAreasFlag:geoFlags.areas})
          }
          if(geoFlags.territories === true || geoFlags.territories === false || geoFlags.territories == null){
            this.setState({selectedAllTerritoriesFlag:geoFlags.territories})
          }
          if(geoFlags.distributors === true || geoFlags.distributors === false || geoFlags.distributors == null){
            this.setState({selectedAllDistributorsFlag:geoFlags.distributors})
          }

        }
        if (this.props.currentForm === 'mt') {

          if (geoData.direct_customers &&geoData.direct_customers.length > 0) {
            this.setState({ selectedDirectCustomer: geoData.direct_customers })
          } else {
            if (__customer) {
              this.setState({ selectedDirectCustomer: __customer })
            }
          }
          if (geoData.regions) {
            // console.log(geoData, "geoData")
            this.setState({ selectedGeoRegions: geoData.regions })
            // console.log("productData=>", productData)
            if (productData.length > 0) {
              this.props.get_distributorsOnResgions(productData[0].direct_customers, geoData.regions)
            }
          }
          if (geoData.distributors) {
            this.setState({ selectedGeoDistributors: geoData.distributors })
          }
          if(geoFlags.regions === true || geoFlags.regions === false || geoFlags.regions == null){
            this.setState({selectedAllRegionsFlag:geoFlags.regions})
          }
          if(geoFlags.distributors === true || geoFlags.distributors === false || geoFlags.distributors == null){
            this.setState({selectedAllDistributorsFlag:geoFlags.distributors})
          }
        }

        isSaveDraft = true
      }
    }

    getData()
    isSaveDraft = true
  }

  componentDidMount() {
    const { get_distributors, get_areas, get_regions, get_towns, get_direct_customer, geo_territories, geo_distributors, geo_areas } = this.props;
    get_areas(); get_distributors(); get_regions(this.props.currentForm); get_towns(); get_direct_customer()
    this.firstTimeData(geo_areas, geo_territories, geo_distributors)
    isSaveDraft = true;
  }

  handleregionchange = (selectedRegions) => {
    if (selectedRegions == null || selectedRegions.length === 0) {
      this.setState({
        selectedGeoRegions: [], myAreas: [], selectedGeoAreas: [], myTerritories: [], selectedGeoTerritories: [],
        selectedGeoDistributors: [], myDistributors: []
      }, () => {
        IsGeographic.isgeographic('onEmpty')
        this.setState({
          selectedAllRegionsFlag: null,
          selectedAllAreasFlag: null,
          selectedAllTerritoriesFlag: null,
          selectedAllDistributorsFlag: null
        })
      })
    }
    if (this.props.currentForm === 'gt' || this.props.currentForm === 'ic') {
      let arr = [];
      if (selectedRegions) {
        selectedRegions.forEach(element => {
          arr.push(element.value);
        });
        this.setState({ selectedGeoRegions: arr, selectedGeoDistributors:[]}, () => {
          IsGeographic.isgeographic('region', this.state, this.props)
          this.handleFilteredArea();
          this.setState({
            selectedAllRegionsFlag: this.state.selectedGeoRegions.length === 0 ? null : this.props.geo_regions?.length === this.state.selectedGeoRegions.length ? true :false,
            selectedAllAreasFlag: this.state.selectedGeoAreas.length === 0 ? null : this.state.myAreas?.length === this.state.selectedGeoAreas.length ? true :false,
            selectedAllTerritoriesFlag: this.state.selectedGeoTerritories.length === 0 ? null : this.state.myTerritories?.length === this.state.selectedGeoTerritories.length ? true : false,
            selectedAllDistributorsFlag: this.state.selectedGeoDistributors.length === 0 ? null : this.state.myDistributors?.length === this.state.selectedGeoDistributors.length ? true : false
          })
        })
      }

    }
    if (this.props.currentForm === 'mt') {

      let arr = [];
      if (selectedRegions === null || selectedRegions.length === 0) {
        this.setState({ selectedGeoRegions: [], selectedGeoAreas: [], selectedGeoTerritories: [], selectedGeoDistributors: [] })
      } else {
        if (selectedRegions) {
          selectedRegions.forEach(element => {
            arr.push(element.value);
          });
          this.setState({ selectedGeoRegions: arr,selectedGeoDistributors:[] }, () => {

            if (productData.length > 0) {
              this.props.get_distributorsOnResgions(productData[0].direct_customers, selectedRegions)

            } else {
              this.props.get_distributorsOnResgions([], selectedRegions)
            }
            this.setState({
              selectedAllRegionsFlag:this.props.geo_regions?.length === this.state.selectedGeoRegions.length ? true :false,
              selectedAllAreasFlag:this.state.myAreas?.length === this.state.selectedGeoAreas.length ? true :false,
              selectedAllTerritoriesFlag:this.state.myTerritories?.length === this.state.selectedGeoTerritories.length ? true : false,
              selectedAllDistributorsFlag:this.state.myGeoDistributorsOnResgion?.length === this.state.selectedGeoDistributors.length ? true : false
            },()=>{
            })
          })
        }
      }
    }
  }


  //direct customer
  handleDirectCustomer = (selectedDirectCustomer) => {

    if (selectedDirectCustomer == null) {
      this.setState({
        selectedDirectCustomer: [], myAreas: [], selectedGeoAreas: [], myTerritories: [], selectedGeoTerritories: [],
        selectedGeoDistributors: [], myDistributors: []
      }, () => {
        IsGeographic.isgeographic('onEmpty')
      })
    }
    if (this.props.currentForm === 'mt') {     
      let arr = [];
      if (selectedDirectCustomer === null) {
        this.setState({ selectedDirectCustomer: [], selectedGeoAreas: [], selectedGeoTerritories: [], selectedGeoDistributors: [] })
      } else {
        if (selectedDirectCustomer) {
          arr.push(selectedDirectCustomer.label);
          this.setState({ selectedDirectCustomer: arr,selectedGeoDistributors:[] }, () => {
            if (selectedDirectCustomer && this.state.selectedGeoRegions.length > 0) {
              this.props.get_distributorsOnResgions(selectedDirectCustomer, this.state.selectedGeoRegions)
            }
          })
        }
      }
    }
  }

  handleFilteredArea() {
    const {
      selectedGeoRegions,
      selectedGeoAreas,
      myAreas
    } = this.state;

    const { geo_areas } = this.props;
    let filteredAreas = [];
    if (selectedGeoRegions.length !== 0 && geo_areas) {
      for (let i = 0; i < selectedGeoRegions.length; i++) {
        filteredAreas.push(
          ...geo_areas.filter(item => {
            return item.Region === selectedGeoRegions[i];
          })
        );
      }

      let selectedAreaFinal = [];
      myAreas.forEach(element => {
        if (selectedGeoAreas.length !== 0) {
          selectedGeoAreas.forEach(e => {
            if (element.guid === e) {
              filteredAreas.length !== 0 && 
              filteredAreas.forEach(area => {
                if(area.guid === e){
                  selectedAreaFinal.push(e);
                  // this.setState({
                  //   selectedGeoAreas: selectedAreaFinal
                  // });
                }
              });
            }
          });
        }
      });

      this.setState({
        myAreas: filteredAreas,
        selectedGeoAreas: selectedAreaFinal
      },()=>{
        this.handleFilteredTown();
        this.setState({
          selectedAllAreasFlag: this.state.selectedGeoAreas.length === 0 ? null : this.state.myAreas?.length === this.state.selectedGeoAreas.length ? true :false,
          selectedAllTerritoriesFlag: this.state.selectedGeoTerritories.length === 0 ? null : this.state.myTerritories?.length === this.state.selectedGeoTerritories.length ? true : false,
          selectedAllDistributorsFlag: this.state.selectedGeoDistributors.length === 0 ? null : this.state.myDistributors?.length === this.state.selectedGeoDistributors.length ? true : false
        })
      });
    }
  }

  handleAreaChange = (selectedArea) => {
    let arr = [];
    if (selectedArea == null || selectedArea.length === 0) {
      this.setState({ selectedGeoAreas: [], selectedGeoTerritories: [], selectedGeoDistributors: [], myTerritories: [], myDistributors: [] },
        () => {
          IsGeographic.isgeographic('onEmpty')
          this.setState({
            selectedAllAreasFlag: null,
            selectedAllTerritoriesFlag: null,
            selectedAllDistributorsFlag: null
          })
        })
    }
    if (selectedArea) {
      selectedArea.forEach(element => {
        arr.push(element.value);
      });
      this.setState({ selectedGeoAreas: arr,selectedGeoDistributors:[] }, () => {
        IsGeographic.isgeographic('area', this.state, this.props)
        this.setState({
          selectedAllAreasFlag: this.state.selectedGeoAreas.length === 0 ? null : this.state.myAreas?.length === this.state.selectedGeoAreas.length ? true :false,
          selectedAllTerritoriesFlag: this.state.selectedGeoTerritories.length === 0 ? null : this.state.myTerritories?.length === this.state.selectedGeoTerritories.length ? true : false,
          selectedAllDistributorsFlag: this.state.selectedGeoDistributors.length === 0 ? null : this.state.myDistributors?.length === this.state.selectedGeoDistributors.length ? true : false
        })
        this.handleFilteredTown();

      })
    }

  }

  handleFilteredTown() {
    const {
      selectedGeoAreas,
      selectedGeoTerritories,
      myTerritories
    } = this.state;
    const { geo_territories } = this.props;
    let filteredSkus = [];
    if (selectedGeoAreas.length !== 0 && geo_territories) {
      for (let i = 0; i < selectedGeoAreas.length; i++) {
        filteredSkus.push(
          ...geo_territories.filter(item => {
            return item.Area === selectedGeoAreas[i];
          })
        );
      }

      let selectedTownFinal = [];
      myTerritories.forEach(element => {
        if (selectedGeoTerritories.length !== 0) {
          selectedGeoTerritories.forEach(e => {
            if (element.guid === e) {
              filteredSkus.length !== 0 && 
              filteredSkus.forEach(terr => {
                if(terr.guid === e){
                  selectedTownFinal.push(e);
                  // this.setState({
                  //   selectedGeoTerritories: selectedTownFinal
                  // });
                }
              });
            }
          });
        }
      });

      this.setState({
        myTerritories: filteredSkus,
        selectedGeoTerritories: selectedTownFinal
      },()=>{
        this.handleFilteredDistributor()
        this.setState({
          selectedAllTerritoriesFlag: this.state.selectedGeoTerritories.length === 0 ? null : this.state.myTerritories?.length === this.state.selectedGeoTerritories.length ? true : false,
          selectedAllDistributorsFlag: this.state.selectedGeoDistributors.length === 0 ? null : this.state.myDistributors?.length === this.state.selectedGeoDistributors.length ? true : false
        })
      });
    }
  }

  handleTerritoryChange = (selectedTerritory) => {
    let arr = [];
    if (selectedTerritory == null || selectedTerritory.length === 0) {
      this.setState({ selectedGeoTerritories: [], selectedGeoDistributors: [], myDistributors: [] }, () => {
        IsGeographic.isgeographic('onEmpty')
        this.setState({
          selectedAllTerritoriesFlag: null,
          selectedAllDistributorsFlag: null
        })
      })
    }
    if (selectedTerritory) {
      selectedTerritory.forEach(element => {
        arr.push(element.value);
      });
      this.setState({ selectedGeoTerritories: arr,selectedGeoDistributors:[] }, () => {
        IsGeographic.isgeographic('territory', this.state, this.props)
        this.setState({
          selectedAllTerritoriesFlag: this.state.selectedGeoTerritories.length === 0 ? null : this.state.myTerritories?.length === this.state.selectedGeoTerritories.length ? true : false,
          selectedAllDistributorsFlag: this.state.selectedGeoDistributors.length === 0 ? null : this.state.myDistributors?.length === this.state.selectedGeoDistributors.length ? true : false
        })
        this.handleFilteredDistributor()
      })
    }

  }

  handleFilteredDistributor() {
    const {
      selectedGeoTerritories,
    } = this.state;
    const { geo_distributors } = this.props;
    let filteredSkus = [];
    if (selectedGeoTerritories.length !== 0 && geo_distributors) {
      for (let i = 0; i < selectedGeoTerritories.length; i++) {
        filteredSkus.push(
          ...geo_distributors.filter(item => {
            return item.Territory === selectedGeoTerritories[i];
          })
        );
      }

      // let selectedSkuFinal = [];
      // myDistributors.forEach(element => {
      //   if (selectedGeoDistributors.length !== 0) {
      //     selectedGeoDistributors.forEach(e => {
      //       if (element.guid === e) {
      //         filteredSkus.length !== 0 &&
      //         filteredSkus.forEach(dist => {
      //           if(dist.guid === e){
      //             selectedSkuFinal.push(e);
      //             // this.setState({
      //             //   selectedGeoDistributors: selectedSkuFinal
      //             // });
      //           }
      //         });
      //         // console.log(selectedSkuFinal);
      //       }
      //     });
      //   }
      // });

      this.setState({
        myDistributors: filteredSkus,
        // selectedGeoDistributors: selectedSkuFinal
      },()=>{
        this.setState({
          selectedAllDistributorsFlag: this.state.selectedGeoDistributors.length === 0 ? null : this.state.myDistributors?.length === this.state.selectedGeoDistributors.length ? true : false
        })
      });
    }
  }

  handleDistributorChange = (selectedDistributors) => {
    let arr = [];
    if (selectedDistributors == null || selectedDistributors.length === 0) {
      this.setState({ selectedGeoDistributors: [] }, () => {
        IsGeographic.isgeographic('onEmpty')
        this.setState({
          selectedAllDistributorsFlag: null
        })
      })
    }
    else{
      if(this.props.currentForm === 'mt'){
        if (selectedDistributors) {
          selectedDistributors.forEach(element => {
            arr.push(element.value);
          });
          this.setState({ selectedGeoDistributors: arr }, () => {
            IsGeographic.isgeographic('distributor', this.state, this.props)
            this.setState({
              selectedAllDistributorsFlag: this.state.selectedGeoDistributors.length === 0 ? null : this.state.myGeoDistributorsOnResgion?.length === this.state.selectedGeoDistributors.length ? true : false
            })
          })
        }
      }
      else{
        if (selectedDistributors) {
          selectedDistributors.forEach(element => {
            arr.push(element.value);
          });
          this.setState({ selectedGeoDistributors: arr }, () => {
            IsGeographic.isgeographic('distributor', this.state, this.props)
            this.setState({
              selectedAllDistributorsFlag: this.state.selectedGeoDistributors.length === 0 ? null : this.state.myDistributors?.length === this.state.selectedGeoDistributors.length ? true : false
            })
          })
        }
      }
    }
  }

  saveData(data, flag, for_newPromotion) {
    const saveData = async (data, flag) => {
      if (!("indexedDB" in window)) {
        console.warn("IndexedDB not supported");
        return;
      }
      // log("db created ")

      const dbName = "gt_form";
      const storeName = "product_store";
      const version = 1; //versions start at 1

      const db = await openDB(dbName, version, {
        upgrade(db, oldVersion, newVersion, transaction) {
          db.createObjectStore(storeName);
        },
      });
      const tx = await db.transaction(storeName, "readwrite");
      const store = await tx.objectStore(storeName);
      if (!for_newPromotion) {
        const value = await store.put({ "key": "geo_123", "value": data }, "geo_detail");       // eslint-disable-line
        const isSave = await store.put({ "key": "draft_123", "value": flag }, "is_draft_saved")       // eslint-disable-line
        await tx.dones;
      
        let resp; let txs; let obj;
        resp = await db
        txs = await resp.transaction(storeName)
        obj = await txs.objectStore(storeName)
        let geoDataRes = await obj.get('geo_detail');
        let draft = await obj.get('is_draft_saved');       // eslint-disable-line


        geoData = geoDataRes ? geoDataRes.value : []
        draft = draft ? draft.value : void 0
       
      } 
      this.props.call_back(this.props.draft_state === true ? true : isSaveDraft === true ? false : flag)
      let isRestrict = await db
        .transaction(storeName)
        .objectStore(storeName)
        .get("is_newPromotion");
      this.props.isRestrict_fromIdb(isRestrict && isRestrict.value)
    }
    if (isSaveDraft === false) {
      saveData(data, flag)
    }
    else {
      isSaveDraft = false
    }
  }

  setFlagDataInDb(data){
   
    const saveFlagData = async (data) => {
      if (!("indexedDB" in window)) {
        console.warn("IndexedDB not supported");
        return;
      }

      const dbName = "gt_form";
      const storeName = "product_store";
      const version = 1; //versions start at 1

      const db = await openDB(dbName, version, {
        upgrade(db, oldVersion, newVersion, transaction) {
          const store = db.createObjectStore(storeName);       // eslint-disable-line
        }
      });
      const tx = await db.transaction(storeName, "readwrite");
      const store = await tx.objectStore(storeName);     
      let value = undefined;       // eslint-disable-line
        value = await store.put({ "key": "sele_geo_123", "value": data }, "selectedAllGeoFlags");
        await tx.dones; 
    }

    saveFlagData(data)

  }

  getGeoData() {
    const getData = async () => {
      if (!("indexedDB" in window)) {
        console.warn("IndexedDB not supported");
        return;
      }
      const dbName = "gt_form";
      const storeName = "product_store";
      const version = 1; //versions start at 1

      const db = await openDB(dbName, version, {

      });
      let result = await db
        .transaction(storeName)
        .objectStore(storeName)
        .get("geo_detail");

        let flagData = await db
        .transaction(storeName)
        .objectStore(storeName)
        .get("selectedAllGeoFlags");

      geoData = result ? result.value : []

      geoFlags = flagData ? flagData.value : []
    }

    getData();
  }

  componentDidUpdate(prevProps, PrevState) {

    const { selectedGeoRegions, selectedDirectCustomer, selectedGeoAreas, selectedGeoTerritories, selectedGeoDistributors } = this.state
    let flag;       // eslint-disable-line
    if ((this.state.selectedGeoRegions !== PrevState.selectedGeoRegions) || (this.state.selectedGeoAreas !== PrevState.selectedGeoAreas) ||
      (this.state.selectedGeoTerritories !== PrevState.selectedGeoTerritories) || (this.state.selectedGeoDistributors !== PrevState.selectedGeoDistributors)
      || (this.state.selectedAllRegionsFlag !== PrevState.selectedAllRegionsFlag) || (this.state.selectedAllAreasFlag !== PrevState.selectedAllAreasFlag)
      || (this.state.selectedAllTerritoriesFlag !== PrevState.selectedAllTerritoriesFlag) || (this.state.selectedAllDistributorsFlag !== PrevState.selectedAllDistributorsFlag)) {
      isSaveDraft = false
      if (isSaveDraft === false) {
        let arr = []
        let flagArray=[];
        if (this.props.currentForm === 'mt') {
          arr = [{
            regions: selectedGeoRegions,
            areas: selectedGeoAreas,
            towns: selectedGeoTerritories,
            direct_customers: selectedDirectCustomer,
            territories: selectedGeoTerritories,
            distributors: selectedGeoDistributors
          }];
          // For Creating select all flags
          flagArray = [
            {
              regions: this.state.selectedGeoRegions.length === 0 ? null : this.state.selectedAllRegionsFlag,
              distributors: this.state.selectedGeoDistributors.length === 0 ? null : this.state.selectedAllDistributorsFlag,
            }
          ]
        }
        if (this.props.currentForm === 'gt' || this.props.currentForm === 'ic') {
          arr = [{
            regions: selectedGeoRegions,
            areas: selectedGeoAreas,
            towns: selectedGeoTerritories,
            direct_customers: selectedDirectCustomer,
            territories: selectedGeoTerritories,
            distributors: selectedGeoDistributors
          }];
          // For Creating select all flags
          flagArray = [
            {
              regions: this.state.selectedGeoRegions.length === 0 ? null : this.state.selectedAllRegionsFlag,
              areas: this.state.selectedGeoAreas.length === 0 ? null : this.state.selectedAllAreasFlag,
              territories: this.state.selectedGeoTerritories.length === 0 ? null : this.state.selectedAllTerritoriesFlag,
              distributors: this.state.selectedGeoDistributors.length === 0 ? null : this.state.selectedAllDistributorsFlag,
            }
          ]
        }

        flag = true
        this.saveData(arr, true)
        this.setFlagDataInDb(flagArray);

      } else {
        isSaveDraft = false
      }
    }

    if (prevProps.geoDistributorsOnResgion !== this.props.geoDistributorsOnResgion) {
      let a = [];
      this.state.selectedGeoDistributors.forEach(element_1 => {
        this.props.geoDistributorsOnResgion.forEach(element_2 => {
          if (element_1 === element_2.guid) {
            a.push(element_1)
          }
        });
      });
    
      this.setState({ myGeoDistributorsOnResgion: this.props.geoDistributorsOnResgion, selectedGeoDistributors: a })

    }

    if ((prevProps.geo_areas !== this.props.geo_areas) || (prevProps.geo_territories !== this.props.geo_territories) ||
      (prevProps.geo_distributors !== this.props.geo_distributors)) {
      let isData = this.props
      this.firstTimeData(isData.geo_areas, isData.geo_territories, isData.geo_distributors, isData.direct_customers)
      isSaveDraft = true
    }
  }

  render(props) {
    const { geo_regions, geo_areas, geo_distributors, geo_territories } = this.props
    const { selectedGeoRegions, selectedGeoAreas, selectedGeoTerritories, selectedGeoDistributors,
      myAreas, myDistributors, myTerritories, selectedDirectCustomer, myGeoDistributorsOnResgion } = this.state
    let arr = [{
      regions: selectedGeoRegions,
      areas: selectedGeoAreas,
      territories: selectedGeoTerritories,
      direct_customers: selectedDirectCustomer,
      distributors: selectedGeoDistributors
    }];
    this.props.counter !== 1 ? this.saveData(arr, this.props.draft_state) : void 0;
    (this.props.counter === 1 && this.state.sync === true) || geoData ? this.getGeoData() : void 0
    // log(this.props.draft_state)
    // log(this.state, !geo_areas)
    return (
      <>
        <div className='product_detail' >
          <p>Geographic Detail</p>
        </div>
     
        <div className='label_id'>
          <label for='prom' >
            Region <span className='mandatory_fields' >*</span>
          </label>
        </div>

        <CustomSelect.MyCustomSelect
          isDisabled={this.props.draftData?.IsExtended === true ? true : false}
          placeholder={geo_regions ? "Region" : "Loading...."}
          allowSelectAll={true}
          isMulti
          options={
            geo_regions
              ? geo_regions.map(item => ({
                value: item.guid,
                label: item.Name
              }))
              : []
          }
          value={geo_regions
            ? geo_regions
              .filter(item => {
                return !selectedGeoRegions ? void 0 : selectedGeoRegions.includes(
                  item.guid
                );
              })
              .map(item => {
                return {
                  value: item.guid,
                  label: item.Name
                };
              })
            : null}
          onChange={this.handleregionchange}
        />
        {this.props.currentForm && (this.props.currentForm === 'gt' || this.props.currentForm === 'ic') &&
          <>
            <div className='label_id'>
              <label for='prom' >
                Area <span className='mandatory_fields' >*</span>
              </label>
            </div>

            <CustomSelect.MyCustomSelect
              isDisabled={this.props.draftData?.IsExtended === true ? true : false}
              placeholder={geo_areas ? "Area" : "Loading..."}
              allowSelectAll={true}
              isMulti
              options={
                myAreas
                  ? myAreas.map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                  : []
              }
              value={myAreas
                ? myAreas
                  .filter(item => {
                    return !selectedGeoAreas ? [] : selectedGeoAreas.includes(
                      item.guid
                    );
                  })
                  .map(item => {
                    return {
                      value: item.guid,
                      label: item.Name
                    };
                  })
                : []}
              onChange={this.handleAreaChange}
            />

          </>}
        {this.props.currentForm && (this.props.currentForm === 'gt' || this.props.currentForm === 'ic') &&
          <>
            <div className='label_id'>
              <label for='prom' >
                Territory <span className='mandatory_fields' >*</span>
              </label>
            </div>

            <CustomSelect.MyCustomSelect
              isDisabled={this.props.draftData?.IsExtended === true ? true : false}
              placeholder={geo_territories ? "Territory" : "Loading...."}
              allowSelectAll={true}
              isMulti
              options={
                myTerritories
                  ? myTerritories.map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                  : []
              }
              value={myTerritories
                ? myTerritories
                  .filter(item => {
                    return !selectedGeoTerritories ? [] : selectedGeoTerritories.includes(
                      item.guid
                    );
                  })
                  .map(item => {
                    return {
                      value: item.guid,
                      label: item.Name
                    };
                  })
                : []}
              onChange={this.handleTerritoryChange}
            />
          </>}

        {(this.props.currentForm === 'gt' || this.props.currentForm === 'ic') &&
          <>
            <div className='label_id'>
              <label for='prom' >
                Distributor <span className='mandatory_fields' >*</span>
              </label>
            </div>
            <CustomSelect.MyCustomSelect
              isDisabled={this.props.draftData?.IsExtended === true ? true : false}
              placeholder={geo_distributors ? "Distributor" : "Loading..."}
              allowSelectAll={true}
              isMulti
              options={
                myDistributors
                  ? myDistributors.map(item => ({
                    value: item.guid,
                    label: `${item.Name} ${item.Code}`
                  }))
                  : []
              }
              value={myDistributors
                ? myDistributors
                  .filter(item => {
                    return !selectedGeoDistributors ? [] : selectedGeoDistributors.includes(
                      item.guid
                    );
                  })
                  .map(item => {
                    return {
                      value: item.guid,
                      label: `${item.Name} ${item.Code}`
                    };
                  })
                : []}
              onChange={this.handleDistributorChange}
            />
          </>
        }

        {this.props.currentForm === 'mt' &&
          <>
            <div className='label_id'>
              <label for='prom' >
                Distributor <span className='mandatory_fields' >*</span>
              </label>
            </div>
            <CustomSelect.MyCustomSelect
              isDisabled={this.props.draftData?.IsExtended === true ? true : false}
              placeholder={"Distributor"}
              allowSelectAll={true}
              isMulti
              options={
                selectedGeoRegions.length > 0 && myGeoDistributorsOnResgion
                  ? myGeoDistributorsOnResgion.map(item => ({
                    value: item.guid,
                    label: `${item.Name} (${item.Code})`
                  }))
                  : []
              }
              value={myGeoDistributorsOnResgion
                ? myGeoDistributorsOnResgion
                  .filter(item => {
                    return !selectedGeoDistributors ? void 0 : selectedGeoDistributors.includes(
                      item.guid
                    );
                  })
                  .map(item => {
                    return {
                      value: item.guid,
                      label: `${item.Name} (${item.Code})`
                    };
                  })
                : null}
              onChange={this.handleDistributorChange}
            />
          </>
        }
      </>
    );
  }
}

// redux 

const mapStateToProps = state => {
  return {
    geo_regions: state.GeoReducer.geoRegions,
    geo_territories: state.GeoReducer.geoTowns,
    geo_areas: state.GeoReducer.geoAreas,
    geo_distributors: state.GeoReducer.geoDistributors,
    directCustomers: state.GeoReducer.directcustomer,
    geoDistributorsOnResgion: state.GeoReducer.geoDistributorsOnResgion,
    temporaryReducer: isEmpty === 1 ? state.TemporaryReducer : void 0,
    draftData: state.CreatePromotionReducer.draftData,

  }
}

const mapDispatchToProps = dispatch => {
  return {
    get_regions: (currentForm) => {
      return dispatch(GeoMiddleware.get_regions(currentForm))
    },
    get_areas: () => {
      return dispatch(GeoMiddleware.get_areas())
    },
    get_towns: () => {
      return dispatch(GeoMiddleware.get_towns())
    },
    get_distributors: () => {
      return dispatch(GeoMiddleware.get_distributors())
    },
    get_direct_customer: arr => {
      return dispatch(GeoMiddleware.get_direct_customer());
    },
    get_distributorsOnResgions: (selectedDirectCustomer, selectedRegions) => {
      return dispatch(GeoMiddleware.get_distributorsOnResgions(selectedDirectCustomer, selectedRegions))
    },

    geo_detail: (arr) => {
      return dispatch(TemporaryMiddleware.geoDetail(arr));
    },
    productDetail: arr => {
      return dispatch(TemporaryMiddleware.geoDetail(arr));
    },

  }
}
export default connect(mapStateToProps, mapDispatchToProps)(GeographicDetail);